<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        :clickableRows=true
        :sorter='{ external: false, resetable: true }'
        :sorterValue="{ column: 'time', asc: false }"
        pagination
        @row-clicked="(item, index) => { clickRow( item,index );  $emit('row-clicked',item,0) }"
      >
      <!--
      <template #time="{item}">
        <td><button v-on:click="$emit('row-clicked',item,0)">{{item.dateAndTime}}</button></td>
      </template>
      -->
        <template #status="{item}">
          <td>
            <CBadge :color="getBadge(item.status)">{{item.status}}</CBadge>
          </td>
        </template>
       <template #msgGPSLink="{item}">
          <td> 
            <a v-bind:href="item.msgGPSLink" target="_blank"><CIcon name="cil-location-pin" /></a>
          </td>
        </template>        
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
//           v-on:click="clickItem1"  
//            v-on:row-clicked="$emit('clickItem2', $event.target.value)" 

export default {
  name: 'CTableWrapper',
  props: { 
    items: Array,
    fields: {
      type: Array,
      default () {
        return [ 
        { key: 'time',             label: 'dateAndTime', _style: 'width:160px;' },
        { key: 'status',           label: 'status', _style: 'width:30px;' },
        { key: 'provider',         label: 'provider', _style: 'width:30px;' },
        { key: 'imei',             label: 'imei', _style: 'width:30px;' },
        { key: 'approxLat',        label: 'providerLat', _style: 'width:30px;' },
        { key: 'approxLong',       label: 'providerLong', _style: 'width:30px;' },
        { key: 'payloadLen',       label: 'payloadLen', _style: 'width:30px;' },
        { key: 'msgType',          label: 'msgType', _style: 'width:30px;' },
        { key: 'msgTimeRTC',       label: 'msgTimeRTC', _style: 'width:30px;' },
        { key: 'msgTimeGPS',       label: 'msgTimeGPS', _style: 'width:30px;' },
        { key: 'msgMCUTemp',       label: 'msgMCUTemp', _style: 'width:30px;' },
        { key: 'msgMCUBatteries',  label: 'msgMCUBatteries', _style: 'width:30px;' },
        { key: 'msgLatitude',      label: 'msgGPSLat', _style: 'width:30px;' },
        { key: 'msgLongitude',     label: 'msgGPSLong', _style: 'width:30px;' },
        { key: 'msgGPSLink',       label: 'msgGPSLink', _style: 'width:30px;' },
        { key: 'msgResetNb',       label: 'msgResetNb', _style: 'width:30px;' },
        { key: 'msgSaveNb',        label: 'msgSaveNb', _style: 'width:30px;' },
        { key: 'msgRecordingNb',   label: 'msgRecordingNb', _style: 'width:30px;' },
        { key: 'msgFWVersion',     label: 'msgFWVersion', _style: 'width:30px;' },
     //   { key: 'payload',          label: 'Payload', _style: 'min-width:40px; max-width:100px;' }
        ]
      }
    },
    caption: {
      type: String,
      default: 'SNMessage'
    },
    clickableRows: Boolean ,
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  methods: {
    clickRow( item,index )
    {
      // console.log('clickRow='+item.time+','+index)      
    },    
    getBadge (status) {
      return (status === 'Active') || (status === 'OK') ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    onTableChange () {
      this.loading = true
      console.log('onTableChange')
      setTimeout(() => {
          this.loading = false
          const agent = this.$refs.externalAgent
          this.loadedItems = agent.currentItems
          this.clickableRows = true
          this.pages = Math.ceil(agent.sortedItems.length / 5)
      }, 1000)
    }
  }  
}
</script>
